import { connect } from 'react-redux';
import { updateConversation, getConversation } from 'core/slices/users';
import { conversation } from 'core/selectors';
import MessagesPane from '../../../components/chat/MessagesPane';

export default connect(
  state => ({
    conversation: conversation(state),
  }),
  {
    getConversation,
    updateConversation,
  },
)(MessagesPane);
